import React from "react";

export const Process = (props) => {
    return (
        <div id="process" className="text-center section-bg">
            <div className="container">
                <div className="section-title">
                    <h2>OUR PROCESS</h2>
                    <p>
                        A proven approach to delivering exceptional results for every project.
                    </p>
                    <div className="bar" />
                </div>
                <div className="row process-row">
                    {props.data
                        ? props.data.map((d, i) => (
                            <div key={`${d.name}-${i}`} className="col-md-3 col-sm-6 process-step">
                                <div className="process-icon-wrapper">
                                    <div className="process-icon">
                                        <i className={d.icon}></i>
                                    </div>
                                    <div className="step-number">{i + 1}</div>
                                </div>
                                <h3>{d.name}</h3>
                                <p>{d.text}</p>
                            </div>
                        ))
                        : "loading"}
                </div>
            </div>
        </div>
    );
};
